import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CartItem } from "../../models/cart";
import { PostalAddressInterface } from "../../models/customer";
import {
  BuildupService,
  OrderResponseInterface,
  OrderSubmitInterface,
  RefundableOrderResponseInterface,
  RefundRequestInterface,
  RefundSubmitInterface,
} from "../../models/order";
import { HttpBaseService } from "@gea-waldviertler-website/shop-lib";
import { IClientAuthorizeCallbackData } from "ngx-paypal";
import { md5 } from 'js-md5';
import { ShippingMethodResponseInterface } from "@gea-waldviertler-website/gea-models";

export interface CachedShippingMethodResponsesInterface {
  [key: string]: ShippingMethodResponseInterface
}

@Injectable()
export class HttpOrderService extends HttpBaseService {

  private cachedShippingMethodResponses: CachedShippingMethodResponsesInterface = {}

  create(order: OrderSubmitInterface): Observable<OrderResponseInterface> {
    const url: string = this.getMainApiBaseUrl() + "/order/"
    return this.http.post<OrderResponseInterface>(url, order)
  }

  validate(order: OrderSubmitInterface): Observable<OrderResponseInterface> {
    const url: string = this.getMainApiBaseUrl() + "/order/validate"
    return this.http.post<OrderResponseInterface>(url, order)
  }

  checkDiscount(order: OrderSubmitInterface): Observable<OrderResponseInterface> {
    const url: string = this.getMainApiBaseUrl() + "/order/check_discount"
    return this.http.post<OrderResponseInterface>(url, order)
  }

  public validatePaypalAuthorizationData(cartUuid: string, ad: IClientAuthorizeCallbackData) {
    const url: string = this.getMainApiBaseUrl() + "/order/" + cartUuid + "/confirm_payment/"
    return this.http.post<undefined>(url, ad)
  }

  public cancelPaypalOrder(cartUuid: string) {
    const url: string = this.getMainApiBaseUrl() + "/order/" + cartUuid + "/cancel_payment"
    return this.http.post<undefined>(url, null)
  }

  getShippingMethod(items: CartItem[], address: PostalAddressInterface | undefined): Observable<ShippingMethodResponseInterface> {
    const hash = md5.hex(JSON.stringify({ items: items, postcode: address?.postalcode, country: address?.country }))
    if (this.cachedShippingMethodResponses[hash]) {
      let obs = new Observable<ShippingMethodResponseInterface>(subscriber => {
        subscriber.next(this.cachedShippingMethodResponses[hash])
      })
      return obs
    }
    const url: string = this.getMainApiBaseUrl() + "/order/shipping_method/"

    return new Observable<ShippingMethodResponseInterface>(subscriber => {
      this.http.post<ShippingMethodResponseInterface>(url, { items: items, address: address }).subscribe(response => {
        this.cachedShippingMethodResponses[hash] = response
        subscriber.next(response)
      })
    })
  }

  getBuildupService(postalcode: string) {
    const url: string = this.getMainApiBaseUrl() + "/order/assembly_service?postalcode=" + postalcode
    return this.http.get<BuildupService>(url)
  }

  findRefundableOrder(request: RefundRequestInterface): Observable<RefundableOrderResponseInterface> {
    const url: string = this.getMainApiBaseUrl() + "/order/refund/search/"
    return this.http.post<RefundableOrderResponseInterface>(url, request)
  }

  submitRefund(data: RefundSubmitInterface): Observable<string> {
    const url: string = this.getMainApiBaseUrl() + "/order/refund/submit/"
    return this.http.post(url, data, { responseType: 'text' })
  }
}
